import { ThemeConfig } from 'antd';

const CHAOS_ANT_DESIGN_THEME: ThemeConfig = {
  token: {
    colorPrimary: '#424242',
    fontFamily: 'Inter',
    fontSize: 14,
    colorText: '#1f2125',
    colorError: '#ef6552',
  },
  components: {
    Badge: {
      dotSize: 10,
    },
    Tabs: {
      itemSelectedColor: '#ef8354',
      inkBarColor: '#ef8354',
      itemColor: '#545559',
    },
    Form: {
      itemMarginBottom: 20,
      verticalLabelPadding: 0,
    },
    Input: {
      paddingInline: 12,
      colorBorder: 'var(--color-border-primary)',
      activeBorderColor: 'var(--color-accent)',
      hoverBorderColor: 'var(--color-accent)',
    },
    InputNumber: {
      hoverBorderColor: 'var(--color-accent)',
      paddingInline: 12,
      colorBorder: 'var(--color-border-primary)',
      activeBorderColor: 'var(--color-accent)',
    },
    Slider: {
      trackBg: 'var(--color-accent)',
      dotActiveBorderColor: 'var(--color-accent)',
      handleActiveColor: 'var(--color-accent)',
      handleColor: 'var(--color-accent)',
      trackHoverBg: 'var(--color-accent)',
      railBg: 'var(--color-muted)',
    },
    Button: {
      contentFontSize: 14,
      contentFontSizeLG: 14,
      colorText: 'var(--color-text-on-accent)',
      defaultBg: '#FFFFFF',
      defaultBorderColor: 'var(--color-border-primary)',
      defaultColor: 'var(--color-text-secondary)',
      primaryShadow: 'none',
      defaultShadow: 'none',
      dangerShadow: 'none',
    },
    Segmented: {
      itemSelectedBg: 'var(--color-accent)',
    },
  },
};

export default CHAOS_ANT_DESIGN_THEME;
